<template>
  <div>
    <modals-container name="modal" />
    <!--banner-->
    <div class="box onsite_ba">
      <dl style="height: 370px">
        <slider ref="slider" :options="options" v-if="someList && someList.length > 0">
          <!-- 直接使用slideritem slot -->
          <slideritem v-for="(item,index) in someList" :key="index" :style="item.style"></slideritem>
          <!-- 设置loading,可自定义 -->
          <div slot="loading">loading...</div>
        </slider>
      </dl>
    </div>
    <!---/banner-->

    <!--我的信息相关-->
    <div class="w1200 wrap on_site_selfinfo" v-if="token">
      <!--我的学习成绩-->
      <div class="col_1 w250 left_info">
        <h3>我的学习成绩</h3>
        <dl>
          <!--dt class="icon_a">
            已完成课程数量<span>{{studyStates.course_finished.length}}</span>
          </dt>
          <dt class="icon_b">
            已参加培训数量<span>{{studyStates.plan_completed.length + studyStates.plan_TBD.length}}</span>
          </dt-->
          <dt class="icon_a">
            获取证书数量<span>{{certNum}}</span>
          </dt>
          <!--dt class="icon_c">
            已获得学时学分<span>33</span>
          </dt-->
          <!--<dt class="icon_d">-->
            <!--参加考试次数<span>{{studyStatesCounts.exam_finished + studyStatesCounts.exam_unfinished}}</span>-->
          <!--</dt>-->
          <!--a href="" class="go_on">继续上一次学习</a-->
        </dl>
      </div>
      <!--/我的学习成绩-->
      <div class="col_2 w930 rdiv">
        <!--课程学习-->
        <div class="right_info_pub position_a">
          <dl>
            <dt>课程任务</dt>
            <dd>
              <a><span class="col_1"><b>{{courseTask_finished}}</b><br />已学习</span></a><a><span class="col_2"><b>{{courseTask_doing}}</b><br />学习中</span></a>
            </dd>
          </dl>
          <div v-if="myCourseList && myCourseList.length == '0'" style="margin: 0 auto; text-align: center;">
            暂无课程学习任务
          </div>
          <table v-if="myCourseList && myCourseList.length > 0" v-for="item in myCourseList" :key="item.id" width="100%" border="0" cellspacing="0" cellpadding="0" class="table_1">
            <thead>
            <tr>
              <td style="height: 30px; line-height: 30px; padding-left: 10px; overflow: hidden; display: inline-block;">{{item.name}}</td><!--标题控制在26个字符内-->
              <!--td><span>{{ dateFormat(new Date(item.updateTime), 'yyyy-MM-dd') }}</span></td-->
              <td><span></span></td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>学习进度：</td>
              <td><a>{{item.per}}%</a></td>
            </tr>
            </tbody>
          </table>
          <p><router-link :to="'/entrain/taskList/course'">查看所有课程任务 ></router-link></p>
        </div>
        <!--/课程学习-->
        <!--培训计划-->
        <div class="right_info_pub position_b">
          <dl>
            <dt>培训计划任务</dt>
            <dd>
              <a><span class="col_1"><b>{{studyStatesCounts.plan_completed}}</b><br />已完成</span></a><a><span class="col_2"><b>{{studyStatesCounts.plan_TBD}}</b><br />待完成</span></a>
            </dd>
          </dl>
          <div v-if="myPlanList && myPlanList.length == '0'" style="margin: 0 auto; text-align: center;">
            暂无培训计划任务
          </div>
          <table v-if="myPlanList && myPlanList.length > 0" v-for="item in myPlanList" :key="item.id" width="100%" border="0" cellspacing="0" cellpadding="0" class="table_1">
            <thead>
            <tr>
              <td style="height: 30px; line-height: 30px; padding-left: 10px; overflow: hidden; display: inline-block;">{{item.trainingPlan.title}}</td><!--标题控制在26个字符内-->
              <td><!--span>{{ dateFormat(new Date(item.updateDate), 'yyyy-MM-dd') }}</span--></td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>学习进度：</td>
              <td><a>{{item.process}}%</a></td>
            </tr>
            </tbody>
          </table>
          <p><router-link :to="'/entrain/taskList/plan'">查看所有计划任务 ></router-link></p>
        </div>
        <!--/培训计划-->
        <!--考试/调查问卷-->
        <div class="right_info_pub position_c">
          <dl>
            <dt>考试任务</dt>
            <dd>
              <a><span class="col_1"><b>{{ examTask_finished }}</b><br />已完成</span></a><a><span class="col_2"><b>{{  examTask_doing }}</b><br />未完成</span></a>
            </dd>
          </dl>
          <div v-if="myExamList && myExamList.length == '0'" style="margin: 0 auto; text-align: center;">
            暂无考试任务
          </div>
          <table v-if="myExamList && myExamList.length > 0" v-for="item in myExamList" :key="item.id" width="100%" border="0" cellspacing="0" cellpadding="0" class="table_1">
            <thead>
            <tr>
              <td style="height: 30px; line-height: 30px; padding-left: 10px; overflow: hidden; display: inline-block;">{{item.title}}</td><!--标题控制在26个字符内-->
              <!--td><span>考试开始：{{ dateFormat(new Date(item.startDate), 'yyyy-MM-dd') }}</span></td-->
              <td><span></span></td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>通过标准：</td>
              <td><a>{{item.passline}} / {{item.score}}</a></td>
            </tr>
            </tbody>
          </table>
          <p><router-link :to="'/entrain/taskList/exam'">查看所有考试任务 ></router-link></p>
        </div>
        <!--/考试/调查问卷-->
      </div>
      <div class="clear"></div>
    </div>
    <!--/我的信息相关-->
    <!--最新推荐课程-->
    <div class="box study_list onsite_b mt30">
      <div class="wrap w1200">
        <div class="top_tit">
          <h3>最新推荐课程</h3>
          <router-link to="/entrain/courseList" class="study_more">更多 ></router-link>
        </div>
        <div class="list">
          <a v-for="item in courseList" :key="item.id"  @click="course_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name" />
                <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" :title="item.name" />
                <!--<span class="price_r" v-if="item.coursePriceList && item.coursePriceList[0].price && item.coursePriceList[0].price != '0'">￥{{item.coursePriceList[0].price}}</span>-->
                <!--<span class="price_r" v-if="!item.coursePriceList || !item.coursePriceList[0].price || item.coursePriceList[0].price == '0'">免费</span>-->
                <span class="price_r">{{getCoursePrice(item.coursePriceList)}}</span>
                <span class="man_num_r">{{item.learnCount}}</span>
              </dt>
              <dd>
                <h3 class="single_ellipsis">{{item.name}}</h3>
                <p v-if="item.teacherList && item.teacherList.length>0">讲师：{{item.teacherList[0].teacherName}}<span v-if="item.teacherList.length>1">等</span></p>
                <p v-if="!item.teacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>

    </div>
    <!--/最新推荐课程-->

    <!--直播课程-->
    <div class="in_con_4 onsite_b h650">
      <div class="wrap w1200">
        <div class="onsite_in_tit">直播课程 <router-link to="/entrain/livePlayList" class="study_more">更多 ></router-link></div>
        <div class="on_line_list">
          <a v-for="item in livePlayList" :key="item.id" @click="livePlay_detail(item.id)">
            <dl>
              <dt>
                <img v-if="item.cover" :src="item.cover" :title="item.title" />
                <img v-if="!item.cover || item.cover==''" src="@/assets/images/live_img.jpg" :title="item.title" />
                <span class="price_r" v-if="item.cost && item.cost != '0'">￥{{item.cost}}</span>
                <span class="price_r" v-if="!item.cost || item.cost == '0'">免费</span>
                <span class="play_con"></span>
                <span class="man_num_r">{{item.livePersonCnt}}</span>
                <span class="play_ing" v-if="item.timeStateName=='进行中'">正在直播{{$utils.substring(item.startTime,10,16)}}-{{$utils.substring(item.endTime,10,16)}}</span>
                <span class="play_end" v-if="item.timeStateName=='已结束'">直播结束</span>
                <span class="play_w_time" v-if="item.timeStateName=='未开始'">{{$utils.substring(item.startTime,0,16)}}-{{$utils.substring(item.endTime,0,16)}}</span>
                <span class="play_none" v-if="item.timeStateName=='未开始'">未开始</span>

                <span class="play_go" v-if="item.timeStateName=='进行中'" @click="viewLivePlay()">观看直播</span>
                <span class="play_go" v-if="item.timeStateName=='已结束'" @click="viewVideo()">观看视频</span>
              </dt>
              <dd>
                <h3 class="single_ellipsis">{{item.name}}</h3>
                <p v-if="item.livePlayTeacherList && item.livePlayTeacherList.length>0">讲师：{{item.livePlayTeacherList[0].teacherName}}<span v-if="item.livePlayTeacherList.length>1">等</span></p>
                <p v-if="!item.livePlayTeacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
      </div>
    </div>
    <!--/直播课程-->
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import ModalBox from '@/components/common/modal/index.vue'
  import InfoBox from '@/components/byl/InfoBox/index.vue'
  import { getCookie } from '@/store/cookies.js'
  import { slider, slideritem } from 'vue-concise-slider'// import slider components
  import { mapState, mapActions } from 'vuex'
  export default {
    components: { slider, slideritem },
    data () {
      return {
        filters: {
          pageNo: 1,
          pageSize: 12,
          title: '',
          type: '01',
          state: '1',
          audit: '1'
        },
        filters1: {
          pageNo: 1,
          pageSize: 12,
          title: '',
          type: '02',
          state: '1',
          audit: '1'
        },
        lists: [],
        lists1: [],
        imageList: [],
        studyStates: {},
        courseList: [],
        studyStatesCounts: {},
        livePlayList: [],
        myPlanList: [],
        myExamList: [],
        examTask_finished: 0,
        examTask_doing: 0,
        myCourseList: [],
        courseTask_finished: 0,
        courseTask_doing: 0,
        certNum: '',
        imageData: {},
        someList: [],
        options: {
          currentPage: 0,
          thresholdDistance: 500,
          thresholdTime: 100,
          autoplay: 10000,
          loop: true,
          direction: 'horizontal',
          loopedSlides: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          speed: 300,
          renderPagination: (h, index) => {
            return h('span', {
              class: 'b-list-span'
            })
          }
        }
      }
    },
    created () {
      this.getCourses()
      this.getLivePlays()
      if (this.token) { // 登录后再取
        this.getStudyStates()
        this.getCertNum()
        this.search({ // 取我的计划
          pageNo: 1,
          pageSize: 2,
          itemType: '05'
        }, 'myPlanList')
        this.search({ // 取我的课程
          pageNo: 1,
          pageSize: 2,
          itemType: '00'
        }, 'myCourseList')
        this.search({ // 取我的考试
          pageNo: 1,
          pageSize: 2,
          itemType: '01'
        }, 'myExamList')
        this.getCertNum()
      }
    },
    mounted () {
      let that = this
      let a = []
      this.getBanners().then(function (r) {
        if (r) {
          r.forEach((o) => {
            let no = {}
            no.style = {
              'background': 'url(' + o.cover + ') no-repeat center center'
            }
            a.push(no)
          })
        }
      })
      that.someList = a
      if (getCookie('user')) {
        if (!getCookie('ifrm_031')) {
          this.hasMemberByUserId(getCookie('user').id).then((r) => {
            if (r) {

            } else { // 没有进入组织结构，提醒用户
              this.showUserInfoBox()
            }
          })
        }
      }
    },
    destroyed () {
    },
    computed: {
      ...mapState('auth', ['user', 'token'])
    },
    methods: {
      ...mapActions('auth', {
        hasMemberByUserId: 'hasMemberByUserId'
      }),
      ...mapActions('orgstructure', {
        addPerson: 'addPerson'
      }),
      dateFormat: utils.dateFormat,
      getCoursePrice (arr) {
        if (!arr || !arr[0] || arr[0].price == '0') {
          return '免费'
        } else {
          return arr[0].price
        }
      },
      getStudyStates () {
        this.$api.post(this.$global.bylApiPath, '/userstate/learningstate', null, r => {
          if (r.data) {
            this.studyStates = r.data
            this.studyStatesCounts = {
              course_finished: this.studyStates.course_finished.length,
              course_unfinished: this.studyStates.course_unfinished.length,
              course_topay: this.studyStates.course_topay.length,
              plan_completed: this.studyStates.plan_completed.length,
              plan_TBD: this.studyStates.plan_TBD.length,
              exam_finished: ((this.studyStates.exam_finished) ? this.studyStates.exam_finished : []).length,
              exam_unfinished: ((this.studyStates.exam_unfinished) ? this.studyStates.exam_unfinished : []).length
            }
          }
        })
      },
      course_detail (id) {
        this.$router.push({path: '/entrain/courseDetail/'+ id})
      },
      livePlay_detail (id) {
        this.$router.push({path: '/byl/livePlayDetail/'+ id})
      },
      getCourses () {
        this.$api.post(this.$global.courseApiPath, '/course/courses', {pageNo: 1, pageSize: 8}, r => {
          if (r.data && r.data.length>0) {
            this.courseList = r.data
          }
        })
      },
      getLivePlays () {
        this.$api.post(this.$global.livePlayApiPath, '/livePlayInfo/findList', {pageNo: 1, pageSize: 8}, r => {
          if (r.data && r.data.length>0) {
            this.livePlayList = r.data
          }
        })
      },
      search (filters, name) {
        api.post(config.bylApiPath, '/studyItemPermissions/myTasks', filters, (r) => {
          if (r.data) {
            this[name] = r.data.slice(0, 2) // 空间只够容纳2个
            if (name == 'myCourseList') {
              this.courseTask_finished = r.data.filter((o) => {
                return o.per == 100
              }).length
              this.courseTask_doing = r.data.filter((o) => {
                return o.per < 100
              }).length
            }
            if (name == 'myExamList') {
              this.examTask_finished = r.data.filter((o) => {
                return o.examIdFinish
              }).length
              this.examTask_doing = r.data.filter((o) => {
                return !o.examIdFinish
              }).length
            }
          } else {
            this[name] = []
          }
        })
      },
      getCertNum () {
        this.$api.post(this.$global.bylApiPath, '/cert/certNum', null, r => {
          this.certNum = r.data
        })
      },
      getBanners () {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.bylBaseCenterPath, '/recommendinfo/search', {audit: '1'}, r => {
            resolve(r.data)
          })
        })
      },
      showUserInfoBox () {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '完善个人资料',
            styles: {
              width: '670',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'infobox',
              template: InfoBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                showCheckBox: true
              } // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              if (val) {
                val.data.loginUserId = getCookie('user').id
                if (val.isValidate) {
                  that.addPerson(val.data) // 调用接口保存
                } else {
                  that.$toasted.show('请填写信息')
                  that.showUserInfoBox()
                }
              }
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/entrain/home.vue